<template>
  <div>
        <div id="cf3" class="fadein">
            <img class="bottom" src="../assets/TAJimages/banner-bg3 1.png">
            <img class="top" src="../assets/TAJimages/banner-bg8.jpeg">
            <img class="fadein" src="../assets/TAJimages/banner-bg1.jpeg">
        </div>
        <div class="overlay"></div>
        <div class="main1">
            <div class="container-fluid">
                <div class="container">
                    <div class="row justify-content-evenly  align-items-center" >
                      <div class="col-12 text-center text-sm-left mb-5">
                            <div class="animate__animated d-flex justify-content-between animate__fadeIn animate__delay-1s" >
                                <img src="../assets/TAJimages/tajbank 1-old.png" class="img-fluid taj-logo" alt="" style="margin-left:-30px;">
                                <img src="@/assets/TAJimages/NIFI-logo.png" alt="NIFI logo" class="nifi-logo img-fluid">
                            </div>
                        </div>
                        <div class="col-lg-8 col-sm-12 text-sm-center text-md-left animated fadeInLeft animate__delay-1s">
                          <div>
                              <h1 class="text-white login__header--text">
                                  Welcome to Retail Banking!
                              </h1>
                              <h5 class="text-white login__header--subtext">Login to access your profile</h5>
                          </div>
                        </div>
                        <div class="col-lg-4 col-sm-12 animated fadeInRight">
                            <div class="form-card">
                            <!-- login section -->
                                <div class="login__section">
                                    <form v-show="step === 1" class="text-center theme-form form needs-validation" @submit.prevent="generateOtp" id="Submit_Form">
                                        <h2>Forgot Password</h2>
                                        <!-- <div class="line"></div> -->
                                        <hr class="line">
                                        <h3>Enter your details to proceed.</h3>
                                        <div class="form-body">
                                            <div class="textfield">
                                                <img src="../assets/TAJimages/SVG/user-1.svg" width="17px" height="19px" alt="">
                                                <div class="divider"></div>
                                                <input type="text" v-model="form.username" id="UserName"  name="UserName" placeholder="Enter Account No/Email/Phone No.">
                                            </div>
                                            <div class="textfield">
                                                <img src="../assets/TAJimages/SVG/lock-1.svg" width="17px" height="19px" id="lock" alt="">
                                                <div class="divider"></div>
                                                <input :type="type" id="newPassword" v-model="form.newPassword"  name="newPassword" placeholder="Enter New Password">
                                                <img src="../assets/TAJimages/SVG/eye-1.svg" @click="showPassword" alt="" class="cursor-pointer">
                                            </div>
                                            <div class="textfield">
                                                <img src="../assets/TAJimages/SVG/lock-1.svg" width="17px" height="19px" id="lock" alt="">
                                                <div class="divider"></div>
                                                <input :type="type_" id="confirmPassword" v-model="form.confirmPassword"  name="ConfirmPassword" placeholder="Confirm New Password">
                                                <img src="../assets/TAJimages/SVG/eye-1.svg" @click="_showPassword" alt="" class="cursor-pointer">
                                            </div>
                                            <div class="textfield">
                                                <feather type="key" width="15px" style="color: #E41613"></feather>
                                                <div class="divider"></div>
                                                <input @keypress="isNumber" @paste.prevent :type="pinType" id="authorizationPIN" v-model="form.authorizationPIN" maxlength="4" pattern="\d*"  name="transaction_pin" placeholder="Enter Transaction Pin">
                                                <img src="../assets/TAJimages/SVG/eye-1.svg" @click="showPin" alt="" class="cursor-pointer">
                                            </div>
                                            <button class="button" :disabled="loading === true" :class="{'submit__btn': loading}" type="submit">
                                                <div v-if="loading" class='loader-box'>
                                                    <div class='loader-15'></div>
                                                </div>
                                                <div v-else>Submit</div>
                                            </button>
                                            <router-link to="/auth/login" class="text-center account-btn forgot-password__link">Back to Log in</router-link>
                                        </div>
                                            <hr>
                                            <p class="copyright">© {{ new Date().getFullYear() }}. All Rights Reserved.</p>
                                    </form>
                                </div>
                                <div v-show="step === 2" class="text-center">
                                    <div class="back-icon" @click="prevStep">
                                        <feather class="feather-icon pt-1" type="chevron-left"></feather>
                                    </div>
                                    <h6 class="header__bvn--text">Reset your password</h6>
                                    <p class="bvn--subtext">An SMS with the One Time Password(OTP) has been sent to your registered mobile number.</p>
                                    <div class="text-center mt-3">
                                        <p class="bvn--subtext">Enter the 6 digit code sent to your mobile number.</p>
                                        <div class="bvn-form mt-3">
                                            <v-otp-input
                                            style="justify-content: center"
                                            ref="otpInput"
                                            input-type="password"
                                            input-classes="otp-input"
                                            separator=""
                                            :num-inputs="6"
                                            :should-auto-focus="true"
                                            :is-input-num="true"
                                            @on-complete="handleOnComplete"
                                            />
                                            <p class="mt-2 text-center">00:{{ countDown }}</p>
                                            <button class="proceed-btn mt-2" @click="validateOTP" :disabled="loading === true" :class="{'submit__btn': loading}" type="button">
                                                <div v-if="loading" class='loader-box'>
                                                    <div class='loader-15'></div>
                                                </div>
                                                <div v-else>Confirm</div>
                                            </button>
                                            <div class="text-center">
                                                <button type="button" class="request-otp" @click="generateNewOtp">Request New OTP</button>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="login--section">
                                            <router-link to="/auth/login" class="text-center account-btn forgot-password__link">Back to Log in</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!-- Plugin used-->
        </div>
    </div>
</template>

<script>
  // import { mapState } from 'vuex';
  import { encrypt, decrypt } from '@/_services/encryption';
  import { headers } from '@/_services/headers'
  export default {
    name: 'forgotPassword',
    components: {
    },
    data:() => ({
      form: {
        username: null,
        newPassword: null,
        confirmPassword: null,
        authorizationPIN: null,
        authorizationType: 1,
        platform: 1,
        customerType: 2,
      },
      type: 'password',
      type_: 'password',
      pinType: 'password',
      loading: false,
      step: 1,
      otp: null,
      countDown: null,
    }),
    computed: {
      // ...mapState({
      //   userPhoneNumber: state => state.dashboard.dashboardData.customerDetails.phoneNumber1,
      // }),
      // maskedPhoneNumber: function() {
      //   let phoneNumber = this.userPhoneNumber;
      //   let maskedPhoneNumber = phoneNumber.substring(7, 7) + '*******' + phoneNumber.substring(phoneNumber.length - 4, phoneNumber.length);
      //   return maskedPhoneNumber;
      // },
    },
    mounted() {
    },
    methods: {
      isNumber(event) {
        // prevent user to enter non-numeric value
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      nextStep() {
        this.step++;
      },
      prevStep() {
        if(this.otp) {
          this.handleClearInput();
        }
        this.step--;
      },
      generateNewOtp() {
        this.handleClearInput();
      },
      // function to set countdown timer for 00:60
      handleCountDown() {
        this.countDown = 60;
        let countDownInterval = setInterval(() => {
          if(this.countDown > 0) {
            this.countDown--;
          } else {
            clearInterval(countDownInterval);
          }
        }, 1000);
      },
      // function to generate OTP
      async generateOtp() {
        // check if form is valid and password and confirm password match
        if(this.form.newPassword !== this.form.confirmPassword) {
          this.$toasted.show('Password and Confirm Password do not match', { 
            theme: 'outline',
            position: 'top-right', 
            type: 'error', 
            icon : 'times', 
            duration: 5000 
          });
          return;
        }
        if (this.form.username && this.form.newPassword && this.form.confirmPassword && this.form.authorizationPIN) {
          this.loading = true;
          const data = this.form;
          const details = {
            username: data.username,
            platform: 1
          };
          const encryptedData = encrypt(details);
          try {
            await this.$http.post(`/Customer/GenerateOtp`, encryptedData, { headers: headers });
            this.loading = false;
            this.nextStep();
            // count down timer
            this.handleCountDown();
          } catch (error) {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            objError.forEach((error) => {
              this.$toasted.show(error, { 
                theme: 'outline',
                position: 'top-right',
                icon : 'times', 
                type: 'error', 
                duration: 10000 
              });
            });
          }
        } else {
          this.$toasted.show('Please fill all the fields', { 
            theme: 'outline',
            position: 'top-right', 
            type: 'error', 
            icon : 'times', 
            duration: 5000 
          });
        }
        
      },
      async resetPassword() {
        // validate OTP
        if (this.otp) {
          this.loading = true;
          try {
            await this.$store.dispatch('resetPassword', this.form).then(response => {
              if(response.status === 200) {
                this.loading = false;
                this.$toasted.show('Password reset successful', { 
                  theme: 'outline',
                  position: 'top-right', 
                  type: 'success', 
                  icon : 'check', 
                  duration: 5000 
                });
                this.$router.push('/auth/login');
              }
              this.loading = false;
            });
          } catch (error) {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$toasted.show(objError.errors[0], { 
              theme: 'outline',
              position: 'top-right',
              icon : 'times', 
              type: 'error', 
              duration: 10000 
            });
            this.loading = false;
          }
        } else {
          this.$toasted.show('Please enter the OTP', { 
            theme: 'outline',
            position: 'top-right', 
            type: 'error', 
            icon : 'times', 
            duration: 30000 
          });
        }
        
      },
      // validate OTP
      async validateOTP() {
        this.loading = true;
        const data = {
          username: this.form.username,
          otp: this.otp,
          platform: 1
        };
        try {
          const encryptedData = encrypt(data);
          this.loading = true;
          const response = await this.$http.post(`/Customer/ValidateOtp`, encryptedData, { headers: headers });
          if (response.status === 200) {
            this.resetPassword();
          } else {
            return false;
          }
        }catch (error) {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          objError.forEach((error) => {
            this.$toasted.show(error, { 
              theme: 'outline',
              position: 'top-right',
              icon : 'times', 
              type: 'error', 
              duration: 10000 
            });
          });
        }
      },
      handleOnComplete(value) {
        this.otp = value;
      },
      handleClearInput() {
        this.$refs.otpInput.clearInput();
      },
      // show/hide password
      showPassword() {
        this.type = this.type === 'text' ? 'password' : 'text';
      },
      _showPassword() {
        this.type_ = this.type_ === 'text' ? 'password' : 'text';
      },
      // show/hide pin
      showPin() {
        this.pinType = this.pinType === 'number' ? 'password' : 'text';
      },
    },
  };
</script>
<style scoped>
* {
    letter-spacing: 0px !important;
}
.submit__btn {
    background-color: #E6E6E6 !important;
}
.login__header--text {
  font-size: 40px;
  margin-bottom: 8px;
}
.login__header--subtext {
  font-size: 20px;
}
/* animation code */
@keyframes gradient {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}

body {
    background-color: #fff;
    max-width: 100vw;
    font-family: 'inter';
    overflow: -moz-scrollbars-vertical;
    overflow-x: hidden;
    overflow-y: auto;
}

@keyframes cf3FadeInOut {
    0% {
        opacity: 1;
    }
    45% {
        opacity: 1;
    }
    55% {
        opacity: 0;
    }
    100% {
        opacity: 0;
    }
}

@keyframes fade {
    0% {
        opacity: 0;
    }

    11.11% {
        opacity: 1;
    }

    33.33% {
        opacity: 1;
    }

    44.44% {
        opacity: 0;
    }

    100% {
        opacity: 0;
    }
}

#cf3 {
    position: fixed;
    height: 100vh;
    width: 100vw;
}

#cf3 img {
height: 100%;
width: 100%;
object-fit: cover;
-webkit-transition: opacity 1s ease-in-out;
-moz-transition: opacity 1s ease-in-out;
-o-transition: opacity 1s ease-in-out;
transition: opacity 1s ease-in-out;
position: absolute;
}

.fadein img {
    opacity: 0;
    animation-name: fade;
    animation-duration: 18s;
    animation-iteration-count: infinite;
    position: absolute;
    left: 0;
    right: 0;
}

#cf3 img:nth-child(1) {
    animation-delay: 0s;
}

#cf3 img:nth-child(2) {
    animation-delay: 6s;
}

#cf3 img:nth-child(3) {
    animation-delay: 12s;
}

.overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /*    background-color: rgba(0, 0, 0, 0.5);*/
    background: linear-gradient(rgba(255, 255,255, 0.9),rgba(0, 0,0, 0.5),rgba(255, 5, 0, 0.11));
}

.form-card {
    width: 400px;
    margin-bottom: 0px !important;
   min-height: 300px;
   /* display: flex;
    justify-content: center; */
   /* flex-direction: column;*/
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7) !important;
    border-radius: 15px;
    box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.5);
    padding: 30px;
 /*   max-width: 400px;*/
}
.theme-form input[type="text"], 
.theme-form input[type="password"] {
  border-color: #efefef;
  font-size: 14px;
  color: #898989;
}
.form-card h2 {
    color: #111827;
    font-weight: 800;
    font-size: 30px;
    /* line-height: 0; */
    margin: 0;
}

.form-card h3 {
    color: #4B5563;
    font-weight: normal;
    font-size: 14px;
    margin-top: 1.5rem;
    margin-bottom: .8rem;
}

.line {
    height: 0;
    padding: 0;
    margin: 1px auto;
    border-radius: 50px;
    border: 2px solid #E41613;
    background-color: #E41613;
    width: 79px;
}

form {
    width: 100%;
}

.textfield {
    width: 100%;
    height: 56px;
    background: #FFFFFF;
    border: 1px solid #E3E3E3;
    box-sizing: border-box;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin: 20px 0;
}

.divider {
    width: 0px;
    height: 10px;
    margin: 0 10px;
    border: 1px solid #E3E3E3;
    background-color: #E3E3E3;
}

.texticon {
    width: 15px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.textfield>input {
    flex: 1;
    height: 50px;
    border: none;
    outline: none;
    font-size: 15px;
    color: #000;
    font-weight: 100;
}

.textfield>input::placeholder {
    font-size: 15px;
    color: #A0A5AF;
    font-weight: lighter;
}
.textfield > select {
   
    border:none;
    text-align:center;
    width:100%;
}

.forgot {
    font-size: 15px;
    display: flex;
    justify-content: right;
    margin-top: 0px;
    margin-bottom: 10px;
    color: #111827;
    font-weight: 600;
    cursor: pointer;
}

.button {
    width: 100%;
    height: 55px;
    color: #fff;
    font-size: 18px;
    margin-top: 5px;
    border: none;
    outline: none;
    background-color: #E41613;
    border-radius: 10px;
    cursor: pointer;
}

.red {
    color: #E41613;
}

.red>a {
    cursor: pointer;
}

.register {
    color: #111827;
    font-size: 15px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    padding: 1rem 0;
}

.white-divider {
    width: 200px;
    height: 0px;
    border: 0.1px solid #FFFFFF;
    display: flex;
    justify-content: center;
    margin: 2rem auto;
}

hr {
    border: none;
    height: .08px;
    width: 100%;
    color: #FFFFFF;
    background-color: #FFFFFF;
    margin: 1.5rem auto;
}

.copyright {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    color: #555555;
}
/*Loader */
.loader-box {
    height: 24px;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    vertical-align: middle;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-transition: 0.3s color, 0.3s border, 0.3s transform, 0.3s opacity;
    transition: 0.3s color, 0.3s border, 0.3s transform, 0.3s opacity;
}

.loader-box [class*="loader-"] {
    display: inline-block;
    width: 50px;
    height: 50px;
    color: inherit;
    vertical-align: middle;
}


.loader-box .loader-15 {
    background: #a927f9;
    background: #df0000;
    position: relative;
    -webkit-animation: loader-15 1s ease-in-out infinite;
    animation: loader-15 1s ease-in-out infinite;
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
    width: 0.25em;
    height: 0.5em;
    margin: 0 0.5em;
}

.loader-box .loader-15:after,
.loader-box .loader-15:before {
    content: "";
    position: absolute;
    width: inherit;
    height: inherit;
    background: inherit;
    -webkit-animation: inherit;
    animation: inherit;
}

.loader-box .loader-15:before {
    right: 0.5em;
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
}

.loader-box .loader-15:after {
    left: 0.5em;
    -webkit-animation-delay: 0.6s;
    animation-delay: 0.6s;
}

.loader-box .loader-in-control {
    position: absolute;
    top: 45px;
    right: 15px;
}

@-webkit-keyframes loader-15 {
    0%, 100% {
        -webkit-box-shadow: 0 0 0 #df0000, 0 0 0 #df0000;
        box-shadow: 0 0 0 #df0000, 0 0 0 #df0000;
    }

    50% {
        -webkit-box-shadow: 0 -0.25em 0 #df0000, 0 0.25em 0 #df0000;
        box-shadow: 0 -0.25em 0 #df0000, 0 0.25em 0 #df0000;
    }
}

@keyframes loader-15 {
    0%, 100% {
        -webkit-box-shadow: 0 0 0 #df0000, 0 0 0 #df0000;
        box-shadow: 0 0 0 #df0000, 0 0 0 #df0000;
    }

    50% {
        -webkit-box-shadow: 0 -0.25em 0 #df0000, 0 0.25em 0 #df0000;
        box-shadow: 0 -0.25em 0 #df0000, 0 0.25em 0 #df0000;
    }
}

.landing-success {
  /*  padding-bottom: 37px !important;
    font-size: 14px;*/
    color: green;
}

.landing-error {
  /*  padding-bottom: 37px !important;
    font-size: 14px;*/
    color: #e41f13;
}


@media only screen and (max-width: 1500px) {
    .forgot {
        font-size: 13px;
        margin-top: 5px;
        margin-bottom: 5px;
    }
    .textfield>input {
        height: 50px;
        font-size: 16px;
    }
    .textfield>input::placeholder {
        font-size: 16px;
    }
    .textfield {
        width: 100%;
        height: 60px;
        margin: 20px 0;
    }
    .texticon {
        width: 18px;
        height: 26px;
    }
    .button {
        height: 50px;
        margin: 1rem 0;
    }
    .register {
        font-size: 13px;
        padding: .8rem 0;
    }
    hr {
        margin: 1.2rem auto;
    }
    .copyright {
        font-size: 12px;
    }
}

@media only screen and (max-width: 768px) {

    .form-card {
        /*    width: 420px;*/
        min-height: 300px;
        /* display: flex;*/
        justify-items: center;
    /*    flex-direction: column;*/
        align-items: center; 
        background-color: rgba(255, 255, 255, 0.6);
        border-radius: 40px;
        box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.5);
        padding: 15px;
    }
}
.account-btn {
    color: #E41613; 
    cursor: pointer;
    font-weight: 500;
}
.select--text {
    font-size: 14px;
    margin-top: 4px;
}

.back-icon {
    margin-bottom: 6px;
   cursor: pointer;
   background-color: #E41613;
    border-radius: 50px;
    text-align: center;
   height: 30px;
   width: 30px;
   color: #fff
}
.feather-icon {
    color: #E41613;
    background-color: #FAE1DC;
    border-radius: 50px;
}
.header__bvn--text {
    text-align: center;
    color: #000;
    margin-bottom: 5px;
    letter-spacing: 0.4px;
    font-size: 1.2rem;
    font-weight: bold;
}
.bvn--subtext {
    font-size: 14px;
    text-align: center;
}
.bvn-form input {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    padding: 0 10px;
    font-size: 1.2rem;
    font-weight: bold;
    color: #000;
    margin-bottom: 5px;
}
.bvn-form input::placeholder {
    color: #ACACAC;
    font-size: 14px;
    font-weight: 300;
}
.bvn-form input[type=text]:focus,
div >>> .otp-input:focus {
    outline: 1px solid #E41613;
    border: none;
}

.proceed-btn  {
    background-color: #E41613;
    color: #fff;
    border-radius: 10px;
    padding: 10px;
    height: 40px;
    width: 200px;
    font-size: 14px;
    margin-top: 5px;
    border: none;
}
div >>> .otp-input {
    width: 40px !important;
    height: 40px !important;
    padding: 6px;
    margin: 0 6px;
    font-size: 16px;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    text-align: center;
}
.bvn-form .otp-input.error {
    border: 1px solid red !important;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
.request-otp {
    margin: 20px 0px;
    border: 1px solid #E41613;
    background: transparent;
    color: #E41613;
    border-radius: 10px;
    padding: 10px;
    height: 40px;
    font-size: 14px;
    width: 150px;
    margin: 30px 0px
}
.alt-means {
    color: #E41613;
    letter-spacing: 0;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}
.alt-means:hover {
    color: #E41613;
    text-decoration: none;
}
.nifi-logo {
  position: relative;
  left: 60px;
  width: 150px
}

@media screen and (max-width: 768px) {
  .nifi-logo {
    width: 100px;
    height: 80px;
    left: 0
  }
  .taj-logo {
    width: 150px;
    height: auto;
  }
}
</style>